<div class="social-media-banner">
  <h1>Explore our community</h1>
  <div class="icons">
    <a href="https://www.tiktok.com/@flynorse" target="_blank"><i class="fa-brands fa-tiktok"></i></a>
    <a href="https://www.instagram.com/flynorse" target="_blank"><i class="fa-brands fa-instagram"></i></a>
    <a href="https://www.facebook.com/flynorse" target="_blank"><i class="fa-brands fa-facebook-f"></i></a>
  </div>
</div>
